
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { GalleryModule } from '@ks89/angular-modal-gallery';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMapboxGLModule } from 'ngx-mapbox-gl';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

import { MaterialModule } from '../modules/material/material.module';
import { ShareDirectivesModule } from 'src/app/core/directives/directives.module';
import { SharePipesModule } from 'src/app/core/pipes/pipes.module';
import { TranslationModule } from 'src/app/i18n/translation.module';
import { environment } from 'src/environments/environment';
import { AccordionSectionModule } from './accordion-section/accordion-section.module';
import { CalculatorModule } from './calculator/calculator.module';
import { CancelTokenModule } from './cancel-token/cancel-token.module';
import { DatePeriodTimeModule } from './date-period-time/date-period-time.module';
import { ShowDocumentsModule } from './documentaions/show-documents/show-documents.module';
import { UploadDocumentsModule } from './documentaions/upload-documents/upload-documents.module';
import { DynamicGridModule } from './dynamic-grid/dynamic-grid.module';
import { FileControllerModule } from './file-controller/file-controller.module';
import { FileUploaderBoxModule } from './file-uploader-box/file-uploader-box.module';
import { FileUploaderModule } from './file-uploader/file-uploader.module';
import { FormFieldAdvancedSearchModule } from './form-fields/form-field-advanced-search/form-field-advanced-search.module';
import { FormFieldAgeRangeModule } from './form-fields/form-field-age-range/form-field-age-range.module';
import { FormFieldCheckerModule } from './form-fields/form-field-checked/form-field-checker.module';
import { DatepickerComponent } from './form-kit/datepicker/datepicker.component';
import { TimepickerComponent } from './form-kit/timepicker/timepicker.component';
import { GetTextDialogModule } from './get-text-dialog/get-text-dialog.module';
import { MobileFileUploaderModule } from './mobile-file-uploader/mobile-file-uploader.module';
import { MobileAnalysisWidgetModule } from './mobiles-analysis-widget/mobiles-analysis-widget.module';
import { PaymentGatewaySelectorModule } from './payment-gateway-selector/payment-gateway-selector.module';
import { PdfReaderModule } from './pdf-reader/pdf-reader.module';
import { PeriodicDatePickerModule } from './periodic-date-picker/periodic-date-picker.module';
import { PeriodicDateTimePickerModule } from './periodic-date-time-picker/periodic-date-time-picker.module';
import { PeriodicTypeModule } from './periodic-type/periodic-type.module';
import { PostalCodeSelectorModule } from './postal-code-map-selector/postal-code-selector.module';
import { SelectSearchModule } from './select-search/select.search.module';
import { SelectionListModule } from './selection-list/selection-list.module';
import { SetPasswordModule } from './set-password/set-password.module';
import { ShowImagesModule } from './show-images/show-images.module';
import { SmartSendConfirmationMapModule } from './smart-send-confirmation-map/smart-send-confirmation-map.module';
import { TextEditorComponent } from './text-editor/text-editor.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    NgbModule,
    FormsModule,
    ShareDirectivesModule,
    ReactiveFormsModule,
    TranslationModule,
    NgxMaterialTimepickerModule,
    SharePipesModule,
    SelectSearchModule,
    SelectionListModule,
    GalleryModule,
    MatDialogModule,
    PdfReaderModule,
    NgxMapboxGLModule.withConfig({
      accessToken: environment.mapBoxToken
    }),
    DatepickerComponent,
    DynamicGridModule,
    FileUploaderModule,
    FormFieldAdvancedSearchModule,
    FormFieldAgeRangeModule,
    FormFieldCheckerModule,
    GetTextDialogModule,
    AccordionSectionModule,
    MobileFileUploaderModule,
    MobileAnalysisWidgetModule,
    PaymentGatewaySelectorModule,
    PeriodicDateTimePickerModule,
    PeriodicDatePickerModule,
    PeriodicTypeModule,
    PostalCodeSelectorModule,
    SetPasswordModule,
    ShowImagesModule,
    TimepickerComponent,
    UploadDocumentsModule,
    DatePeriodTimeModule,
    ShowDocumentsModule,
    SmartSendConfirmationMapModule,
    CancelTokenModule,
    CalculatorModule,
    FileUploaderBoxModule,
    FileControllerModule,
    SelectSearchModule,
    TextEditorComponent,
  ],
  exports: [
    SelectSearchModule,
    SelectionListModule,
    DatepickerComponent,
    DynamicGridModule,
    FileUploaderModule,
    FormFieldAdvancedSearchModule,
    FormFieldAgeRangeModule,
    FormFieldCheckerModule,
    GetTextDialogModule,
    AccordionSectionModule,
    MobileFileUploaderModule,
    MobileAnalysisWidgetModule,
    PaymentGatewaySelectorModule,
    PeriodicDateTimePickerModule,
    PeriodicDatePickerModule,
    PeriodicTypeModule,
    PostalCodeSelectorModule,
    SetPasswordModule,
    ShowImagesModule,
    TimepickerComponent,
    UploadDocumentsModule,
    DatePeriodTimeModule,
    PdfReaderModule,
    ShowDocumentsModule,
    SmartSendConfirmationMapModule,
    CancelTokenModule,
    CalculatorModule,
    FileUploaderBoxModule,
    FileControllerModule,
    SelectSearchModule,
    TextEditorComponent
  ]
})
export class ComponentsShareModule { }
